import { useEffect } from 'react';

/**
 * Sets the document title and meta description per page. A tiny hand-rolled
 * alternative to react-helmet — one dependency fewer for a site this size.
 */
export default function usePageMeta(title, description) {
  useEffect(() => {
    const previous = document.title;
    document.title = title ? `${title} — Metropolitan Church of God` : 'Metropolitan Church of God';

    let tag = document.querySelector('meta[name="description"]');
    const previousDesc = tag?.getAttribute('content');

    if (description) {
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('name', 'description');
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', description);
    }

    return () => {
      document.title = previous;
      if (description && tag && previousDesc) tag.setAttribute('content', previousDesc);
    };
  }, [title, description]);
}
